<template>
  <!-- ผลตรวจสลิป 1 ใบ (ใต้รูปสลิปใน drawer) + ปุ่มตรวจอีกครั้ง -->
  <div class="border rounded-lg px-2 py-1 mt-1 mb-2 text-xs-1/2" :class="boxClass">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <span class="font-weight-bold">
        <i class="mdi mr-1" :class="icon"></i>
        {{ verify ? verify.label : 'ยังไม่ได้ตรวจสลิป' }}
      </span>
      <button v-if="kind && id && canRecheck && (!verify || verify.retryable)" type="button" class="btn btn-sm text-xs-1/2"
        :class="verify ? 'btn-warning py-0 px-2 rounded-lg' : 'btn-link p-0'" :disabled="loading"
        @click.stop="recheck">
        <i class="mdi" :class="loading ? 'mdi-loading mdi-spin' : 'mdi-refresh'"></i> ตรวจอีกครั้ง
      </button>
    </div>
    <template v-if="verify">
      <div v-if="verify.message && verify.status !== 'passed'">{{ verify.message }}</div>
      <div v-if="verify.slip_amount != null">
        ยอดในสลิป <b>{{ money(verify.slip_amount) }}</b>
        <span v-if="verify.expected_amount != null"> / ต้องชำระ {{ money(verify.expected_amount) }}</span>
      </div>
      <div v-if="verify.sender_name || verify.receiver_name" class="text-gray-600">
        {{ verify.sender_name || '-' }} <span v-if="verify.sender_bank">({{ verify.sender_bank }})</span>
        → {{ verify.receiver_name || '-' }} <span v-if="verify.receiver_bank">({{ verify.receiver_bank }})</span>
      </div>
      <div v-if="verify.date || verify.trans_ref" class="text-gray-400">
        <span v-if="verify.date">{{ formatDate(verify.date) }}</span>
        <span v-if="verify.trans_ref"> · Ref {{ verify.trans_ref }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'SlipVerifyDetail',
  props: {
    verify: { type: Object, default: null },
    // customer (รายการชำระ) | preemption (ใบแจ้งหนี้ใบจอง) | powngan (เคลียร์หนี้งานโป๊ว)
    kind: { type: String, default: '' },
    id: { type: [String, Number], default: null },
    // role ที่ API ตรวจซ้ำยอม (SlipVerifyController) ไม่ยอม = ไม่โชว์ปุ่ม
    canRecheck: { type: Boolean, default: true },
  },
  data() {
    return { loading: false }
  },
  computed: {
    level() {
      return this.verify ? this.verify.level : 'warn'
    },
    boxClass() {
      return this.level === 'ok' ? 'border-success text-success' : this.level === 'danger' ? 'border-danger text-danger' : 'border-warning text-warning'
    },
    icon() {
      return this.level === 'ok' ? 'mdi-check-decagram' : this.level === 'danger' ? 'mdi-alert-octagon' : 'mdi-alert'
    },
  },
  methods: {
    money(v) {
      return parseFloat(v || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDate(v) {
      const m = moment(v)
      return m.isValid() ? `${m.format('DD/MM/')}${m.year() + 543} ${m.format('HH:mm')}` : v
    },
    async recheck() {
      try {
        this.loading = true
        const res = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/slip-verify/${this.kind}/${this.id}`)
        this.$emit('updated', res.data && res.data.verify)
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || 'ตรวจสลิปไม่สำเร็จ'
        this.$swal ? this.$swal({ icon: 'error', text: msg }) : alert(msg)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
